// extracted by mini-css-extract-plugin
module.exports = {"errorCard":"error_errorCard__m_26w","buttonContainer":"error_buttonContainer___BXbS"};